export default __webpack_public_path__ + "static/media/ITR-33.1f57fc19.png";